import { z } from 'zod';
import * as t from 'Shared/model/basic';
import {lineup} from 'Shared/model/lineup';


const managerRequest = z.object({
	email: t.email,
	artistName: z.string(),
	time: t.dateTime
});

export const eventParent = z.object({
	_id: t.id(),
	siteId: t.id(),
	slug: z.string(),
	name: z.string(),
	times: t.eventCalendarSettings,
	shortDescription: z.string().max(200),
	buyOrBook: z.object({
		type: z.enum(['url','embed','free']),
		buttonLabel: z.enum(['buyNow','bookNow','custom']).optional(),
		customPrice: z.string().max(32).optional(),
		purchaseLink: t.url.optional(),
		embed: z.any().optional(),
	}),
	//TODO rename to 'posterType'. There's an image and its different
	imageType: z.union([z.literal('auto'),z.literal('poster'),z.literal('photo')]),
	poster: t.image,
	/* The image is sometimes used to help construct the poster */
	imageDimensions: z.union([z.literal('landscape'),z.literal('portrait'),z.literal('square')]),
	image: t.image,		 //XXX better to put imageDimensions into image so both defined or undefined together
//	shareImage: t.image, 
	fbPosterSettings: t.posterSettings,
	facebookImage: t.image,
	instagramImage: t.image,
	announceOnFacebook:z.boolean(),
	announceOnInstagram:z.boolean(),
	status: z.string().max(100),	//XXX can do better
	scheduleDate: t.dateTime, 
	announceDate: t.dateTime,

	//TODO Should be one or the other (or neither)
	managerRequest: managerRequest.optional(),
	artistId: t.id().optional(),

	posterNEW: z.object({
		posterId:  t.id().optional(),
		design:    z.any().optional(),
		hash:      z.string().optional(),
		formats:   t.imageFormats.optional(),
		dev:       z.boolean().optional(),
		isCurrent: z.boolean().optional(),
		/* Written when the event is created. Non-music events predating the builder don't carry it,
		   and stay on the old poster and its image selector. */
		usesBuilder: z.boolean().optional(),
	}).optional(),
})
.partial().required({
	_id: true,
	siteId: true,   //FIXME only in server I think
	slug: true,
	status: true
});

//TODO make these events strict. Currently cross-contamination

export const musicEvent = eventParent.extend({
	eventType: z.literal('music'), 
	musicPosterSource: z.string().max(16).optional(),  //FIXME
	lineup: lineup,
});

export type MusicEvent = z.infer<typeof musicEvent>;

export const socialEvent = eventParent.extend({
	eventType: z.literal('social'), 
	nonMusicDescription: z.string().max(200).optional(),
	nonMusicPosterSource: z.string().max(16).optional(),
});

export type SocialEvent = z.infer<typeof socialEvent>;

export const tvEvent = eventParent.extend({
	eventType: z.literal('tv'), 
	nonMusicDescription: z.string().max(200).optional(),
	nonMusicPosterSource: z.string().max(16).optional(),
});

export type TvEvent = z.infer<typeof tvEvent>;

export const eventDoc = z.discriminatedUnion('eventType',[musicEvent,socialEvent,tvEvent]);

export type EventDoc = z.infer<typeof eventDoc>;

export const eventDocs = z.array(eventDoc);
export type EventDocs = z.infer<typeof eventDocs>;

export type EventType = 'music'|'social'|'tv';

/* How the types read where they are picked over rather than named in full — the event's own
   type selector says 'Music Event' and so on. */
export const eventTypeNames: Record<string,string> = {
	music: 'Music',
	social: 'Social',
	tv: 'Televised'
};

export const posterImageFields = ['hash','formats','dev','isCurrent'];

/* The builder's events are the ones carrying its subdoc: written at creation (usesBuilder) for a
   new event, and by the builder itself for a music event that was already on it. Events predating
   it have no posterNEW at all and stay on the old poster — the event type alone doesn't say, since
   music events go back further than the builder does. */
export function usesNewPoster(event:EventDoc)
{
	return event.posterNEW != null;
}

export function eventPosterField(event:EventDoc)
{
	return usesNewPoster(event) ? 'posterNEW' : 'poster';
}

/* The rendered poster to show: the new builder's once it has been captured, otherwise the old one. */
export function eventPosterImage(event:EventDoc)
{
	if (usesNewPoster(event) && event.posterNEW?.hash)
		return event.posterNEW;
	return event.poster;
}

/*
export class EventCollection
{
	schema = event;

//FIXME REQUIRED TO UPDATE CALENDAR!!
//	hooks:XXX,

//	indexes: XXXX

	images = {
		shareImage: imageSize.squareAllSizes,
		builtPoster: imageSize.squareAllSizes,
		photo: imageSize.landscape,
		image: imageSize.portrait07071AllSizes,
		facebookImage: imageSize.facebookBanner,
		instagramImage: imageSize.squareAllSizes
	}
}
//XXX Q:
// 1. Are these just a specs for what exists? 
//      Can I use them to create the images?
//      
*/
